"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Basic"] = 1] = "Basic";
    NotificationType[NotificationType["Administrative"] = 2] = "Administrative";
    NotificationType[NotificationType["ActionNeeded"] = 4] = "ActionNeeded";
    NotificationType[NotificationType["Informative"] = 8] = "Informative";
    NotificationType[NotificationType["System"] = 16] = "System";
    NotificationType[NotificationType["Welcome"] = 32] = "Welcome";
    NotificationType[NotificationType["LabResults"] = 64] = "LabResults";
    NotificationType[NotificationType["SampleDesignCompleted"] = 128] = "SampleDesignCompleted";
    NotificationType[NotificationType["SampleCollectionCompleted"] = 256] = "SampleCollectionCompleted";
    NotificationType[NotificationType["SurveyCompleted"] = 512] = "SurveyCompleted";
    NotificationType[NotificationType["SampleResults"] = 1024] = "SampleResults";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=NotificationType.js.map